module.exports = __webpack_public_path__ + "img/UTEAST-4.48466bf8.jpg";